import { Outlet } from "react-router-dom";


const Order = () => {
  return (<Outlet />)
}
export default Order;
